module.exports = __webpack_public_path__ + "img/NORDIC_HIGH_GLYCEMIC.acdb4e3b.png";